import { render, staticRenderFns } from "./CopilotPartnerInsights.vue?vue&type=template&id=48c1a211&"
import script from "./CopilotPartnerInsights.vue?vue&type=script&lang=js&"
export * from "./CopilotPartnerInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports